import { Card } from "shared/components/Card";
import { SelectedLender } from "../types";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { HugeiconsIcon } from "@hugeicons/react";
import { House03Icon } from "@hugeicons-pro/core-solid-rounded";
import { formatLabel } from "../utils";

const STATUS_VARIANT: Record<SelectedLender["submissionStatus"], BadgeVariant> =
  {
    submitted: BadgeVariant.PRIMARY,
    in_review: BadgeVariant.WARNING,
    approved: BadgeVariant.SUCCESS,
    declined: BadgeVariant.ERROR
  };

export const LenderCard = (lender: SelectedLender) => {
  return (
    <Card className="flex items-center gap-4 p-4">
      {lender.logoUrl ? (
        <img
          src={lender.logoUrl}
          alt={lender.name}
          className="size-10 shrink-0 rounded-md object-contain"
        />
      ) : (
        <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-alpha-40">
          <HugeiconsIcon
            icon={House03Icon}
            size={20}
            className="text-content-300"
          />
        </div>
      )}
      <div className="flex-1">
        <p className="truncate text-sm font-medium text-content-1000">
          {lender.name}
        </p>
        <p className="truncate text-xs text-content-300">{lender.id}</p>
      </div>
      <Badge
        variant={STATUS_VARIANT[lender.submissionStatus] ?? BadgeVariant.BASE}
        size={BadgeSize.SM}
      >
        {formatLabel(lender.submissionStatus)}
      </Badge>
    </Card>
  );
};
